import request from "@/utils/request";


export default function agentUnBind(card) {
    return request({
        url: `/user/card/agentUnBind/${card}`,
        method: 'post',
    })
}
